import { put, takeEvery, takeLatest, all, call } from "redux-saga/effects";
import Constants from "common/Constants";
import { ConstantsServer } from "utils/CommonApi";
import axios from "axios";
import qs from "qs";

import * as types from "containers/starshop/ActionType";
import {
	STAR_POINT_SUCCESS,
	STAR_POINT_FAILURE,
	PRODUCT_LIST_SUCCESS,
	PRODUCT_LIST_FAILURE,
	POINT_USELIST_SUCCESS,
	POINT_USELIST_FAILURE,
	POINT_SAVELIST_SUCCESS,
	POINT_SAVELIST_FAILURE,
	SET_GOALS_SUCCESS,
	SET_GOALS_FAILURE,
	GET_GOALS_SUCCESS,
	GET_GOALS_FAILURE,
	DELETE_TARGET_SUCCESS,
	DELETE_TARGET_FAILURE,
	EXCHANGE_PRODUCT_SUCCESS,
	EXCHANGE_PRODUCT_FAILURE,
	EXCHANGE_HISTORY_SUCCESS,
	EXCHANGE_HISTORY_FAILURE,
	RESEND_PRODUCT_SUCCESS,
	RESEND_PRODUCT_FAILURE,
	PROFILE_PHOTO_SUCCESS,
	PROFILE_PHOTO_FAILURE,
	MMBR_TYPE_SUCCESS,
	MMBR_TYPE_FAILURE,
} from "containers/starshop/Action";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const injectQueryParam = (api, param) => {
	if (typeof api !== "string") return;

	for (let key in param) {
		let regExp = new RegExp("{" + key + "}", "g");
		api = api.replace(regExp, param[key]);
	}
	return api;
};

function* starPointSaga(action) {
	try {
		const headerParam = action.payload.headerParam;

		axios.defaults.headers.common["user-id"] = headerParam.user_id;

		let param = {
			REQUEST_API: Constants.STARSHOP_API.MY_POINT,
			HTTP_METHOD: Constants.HTTP_METHOD.GET,
		};

		let queryParam = {
			CUSTOMER_NUMBER: action.payload.customerNumber,
		};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});

		const result = JSON.parse(data.RESP_RESULT.RESP_RESULT.result);

		yield put(STAR_POINT_SUCCESS(result));
	} catch (e) {
		yield put(STAR_POINT_FAILURE(e.message));
	}
}

function* productListSaga(action) {
	try {
		const headerParam = action.payload.headerParam;

		axios.defaults.headers.common["user-id"] = headerParam.user_id;

		let param = {
			REQUEST_API: Constants.STARSHOP_API.PRODUCT_LIST,
			HTTP_METHOD: Constants.HTTP_METHOD.GET,
		};

		let queryParam = {};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});

		const result = JSON.parse(data.RESP_RESULT.RESP_RESULT.result);

		yield put(PRODUCT_LIST_SUCCESS(result));
	} catch (e) {
		yield put(PRODUCT_LIST_FAILURE(e));
	}
}

function* pointUseListSaga(action) {
	try {
		// const headerParam = action.payload.headerParam;

		// axios.defaults.headers.common["user-id"] = headerParam.user_id;
		const envState = String(process.env.REACT_APP_ENV).trim() || "local";

		let serviceType;
		if (envState === "real") {
			serviceType = "SH01";
		} else {
			serviceType = "SH02";
		}

		let param = {
			REQUEST_API: Constants.STARSHOP_API.POINT_HISTORY_LIST,
			HTTP_METHOD: Constants.HTTP_METHOD.GET,
		};

		let queryParam = {
			SERVICE_TYPE: serviceType,
			CUSTOMER_NUMBER: action.payload.customerNumber,
			MIN_DATE: action.payload.startDate,
			MAX_DATE: action.payload.endDate,
		};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});

		const result = JSON.parse(data.RESP_RESULT.RESP_RESULT.result);

		yield put(POINT_USELIST_SUCCESS(result));
	} catch (e) {
		yield put(POINT_USELIST_FAILURE(e));
	}
}

function* pointSaveListSaga(action) {
	try {
		// const headerParam = action.payload.headerParam;

		// axios.defaults.headers.common["user-id"] = headerParam.user_id;

		let param = {
			REQUEST_API: Constants.STARSHOP_API.POINT_HISTORY_LIST,
			HTTP_METHOD: Constants.HTTP_METHOD.GET,
		};

		let queryParam = {
			SERVICE_TYPE: "SAVE",
			CUSTOMER_NUMBER: action.payload.customerNumber,
			MIN_DATE: action.payload.startDate,
			MAX_DATE: action.payload.endDate,
		};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});

		const result = JSON.parse(data.RESP_RESULT.RESP_RESULT.result);

		yield put(POINT_SAVELIST_SUCCESS(result));
	} catch (e) {
		yield put(POINT_SAVELIST_FAILURE(e));
	}
}

function* setGoalsSaga(action) {
	try {
		const customerNumber = action.payload.customerNumber;
		const contractNumber = action.payload.contractNumber;
		const productParam = action.payload.productParam;

		const domain = ConstantsServer.SERVER_DOMAIN.GW_SMARTALL_MID_DOMAIN;

		let param = {
			REQUEST_API: Constants.STARSHOP_API.SET_GOALS,
			HTTP_METHOD: Constants.HTTP_METHOD.POST,
			DOMAIN: domain,
			BODY: {
				contractNumber: contractNumber,
				customerNumber: customerNumber,
				rewardCode: productParam.rewardCode,
				rewardTitle: productParam.rewardDetail,
				rewardDetail: productParam.rewardDetail,
				prodThumimgPath: productParam.prodThumingPath,
				goalPerRwrdCnt: productParam.goalPerRwrdCnt,
				goalAtainYn: "N",
				goalUseYn: "Y",
				regUser: customerNumber,
				goalStupDt: productParam.goalStupDt,
			},
		};

		let queryParam = {};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		if (param.HTTP_METHOD !== Constants.HTTP_METHOD.GET && param.BODY !== null) {
			param.BODY = JSON.stringify(param.BODY);
		}

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});

		yield put(SET_GOALS_SUCCESS(action.payload.state));
	} catch (e) {
		yield put(SET_GOALS_FAILURE(e));
	}
}

function* updateTargetSaga(action) {
	try {
		const domain = ConstantsServer.SERVER_DOMAIN.GW_SMARTALL_MID_DOMAIN;

		let param = {
			REQUEST_API: Constants.STARSHOP_API.GET_TARGET_PRODUCT,
			HTTP_METHOD: Constants.HTTP_METHOD.GET,
			DOMAIN: domain,
		};

		let queryParam = {
			CUSTOMER_NUMBER: action.payload.customerNumber,
			CONTRACT_NUMBER: action.payload.contractNumber,
		};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});
		//const result = JSON.parse(data.RESP_RESULT);
		yield put(GET_GOALS_SUCCESS(data.RESP_RESULT.RESP_RESULT));
	} catch (e) {
		yield put(GET_GOALS_FAILURE(e));
	}
}

function* deleteTargetSaga(action) {
	try {
		const domain = ConstantsServer.SERVER_DOMAIN.GW_SMARTALL_MID_DOMAIN;

		let param = {
			REQUEST_API: Constants.STARSHOP_API.DELETE_TARGET_PRODUCT,
			HTTP_METHOD: Constants.HTTP_METHOD.POST,
			DOMAIN: domain,
		};

		let queryParam = {
			CUSTOMER_NUMBER: action.payload.customerNumber,
		};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		if (param.HTTP_METHOD !== Constants.HTTP_METHOD.GET && param.BODY !== null) {
			param.BODY = JSON.stringify(param.BODY);
		}

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});
		//const result = JSON.parse(data.RESP_RESULT);

		yield put(DELETE_TARGET_SUCCESS(action.payload.state));
	} catch (e) {
		yield put(DELETE_TARGET_FAILURE(e));
	}
}

function* exchangeProductSaga(action) {
	try {
		const customerNumber = action.payload.customerNumber;
		const contractNumber = action.payload.contractNumber;
		const rewardCode = action.payload.rewardCode;
		const phoneNumber = action.payload.phoneNumber;
		const receiver = action.payload.receiver;

		const envState = String(process.env.REACT_APP_ENV).trim() || "local";

		let serviceType;
		if (envState === "real") {
			serviceType = "SH01";
		} else {
			serviceType = "SH02";
		}

		const domain = ConstantsServer.SERVER_DOMAIN.GW_SMARTALL_MID_DOMAIN;

		let param = {
			REQUEST_API: Constants.STARSHOP_API.EXCHANGE_PRODUCT,
			HTTP_METHOD: Constants.HTTP_METHOD.POST,
			DOMAIN: domain,
			BODY: {
				ContaractNumber: contractNumber,
				CustomerNumber: customerNumber,
				RewardCode: rewardCode,
				RCV_CTN: phoneNumber,
				RECEIVER: receiver,
			},
		};

		let queryParam = {
			CONTRACT_NUMBER: contractNumber,
			CUSTOMER_NUMBER: customerNumber,
			SERVICE_TYPE: serviceType,
			REWORD_CODE: rewardCode,
		};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		if (param.HTTP_METHOD !== Constants.HTTP_METHOD.GET && param.BODY !== null) {
			param.BODY = JSON.stringify(param.BODY);
		}

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});

		yield put(EXCHANGE_PRODUCT_SUCCESS(data.RESP_RESULT.RESP_RESULT));
	} catch (e) {
		console.log(e);
		yield put(EXCHANGE_PRODUCT_FAILURE(e));
	}
}

function* exchangeHistorySaga(action) {
	try {
		const customerNumber = action.payload.customerNumber;
		const contractNumber = action.payload.contractNumber;
		const startDate = action.payload.startDate;
		const endDate = action.payload.endDate;

		const envState = String(process.env.REACT_APP_ENV).trim() || "local";

		const domain = ConstantsServer.SERVER_DOMAIN.GW_SMARTALL_MID_DOMAIN;

		let param = {
			REQUEST_API: Constants.STARSHOP_API.EXCHANGE_HISORY,
			HTTP_METHOD: Constants.HTTP_METHOD.GET,
			DOMAIN: domain,
		};

		let queryParam = {
			CONTRACT_NUMBER: contractNumber,
			CUSTOMER_NUMBER: customerNumber,
			MIN_DATE: startDate,
			MAX_DATE: endDate,
		};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		if (param.HTTP_METHOD !== Constants.HTTP_METHOD.GET && param.BODY !== null) {
			param.BODY = JSON.stringify(param.BODY);
		}

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});
		let parseData;

		if (data && data.RESP_RESULT && data.RESP_RESULT.RESP_RESULT.result) {
			const result = data.RESP_RESULT.RESP_RESULT.result;
			parseData = JSON.parse(result);
			// console.log('result', result);
			// console.log('result', typeof result);
			// console.log('result', typeof JSON.parse(result));
			// console.log(parseData);
		}

		// const result = JSON.parse(JSON.stringify(data));
		// yield put(EXCHANGE_HISTORY_SUCCESS(result.RESP_RESULT.RESP_RESULT));
		yield put(EXCHANGE_HISTORY_SUCCESS(parseData));
	} catch (e) {
		//console.log(e);
		yield put(EXCHANGE_HISTORY_FAILURE(e));
	}
}

function* resendProductSaga(action) {
	try {
		const customerNumber = action.payload.customerNumber;
		const contractNumber = action.payload.contractNumber;
		const rewardCode = action.payload.rewardCode;
		const orderCode = action.payload.orderCode;

		const domain = ConstantsServer.SERVER_DOMAIN.GW_SMARTALL_MID_DOMAIN;

		let param = {
			REQUEST_API: Constants.STARSHOP_API.RESEND_PRODUCT,
			HTTP_METHOD: Constants.HTTP_METHOD.POST,
			DOMAIN: domain,
			// BODY: {
			//     customerNumber : customerNumber,
			//     contractNumber : contractNumber,
			//     orderCode : orderCode,
			//     rewardCode : rewardCode
			//  },
		};

		let queryParam = {
			CUSTOMER_NUMBER: customerNumber,
			CONTRACT_NUMBER: contractNumber,
			ORDER_NO: orderCode,
			REWARD_CODE: rewardCode,
		};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		if (param.HTTP_METHOD !== Constants.HTTP_METHOD.GET && param.BODY !== null) {
			param.BODY = JSON.stringify(param.BODY);
		}

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});

		yield put(RESEND_PRODUCT_SUCCESS(data.RESP_RESULT.RESP_RESULT));
	} catch (e) {
		console.log(e);
		yield put(RESEND_PRODUCT_FAILURE(e));
	}
}

function* profilePhotoSaga(action) {
	try {
		const mmbrSeq = action.payload.mmbrSeq;
		const pedcCd = action.payload.pedcCd;

		const param = {
			REQUEST_API: Constants.MYPAGE_API.MMBR_INFO,
			HTTP_METHOD: Constants.HTTP_METHOD.GET,
		};

		let queryParam = {
			MMBR_SEQ: mmbrSeq,
			PEDC_CD: pedcCd,
		};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});

		//const result = JSON.parse(data.RESP_RESULT.RESP_RESULT.result);

		yield put(PROFILE_PHOTO_SUCCESS(data.RESP_RESULT.RESP_RESULT));
	} catch (e) {
		yield put(PROFILE_PHOTO_FAILURE(e));
	}
}

function* mmbrTypeSaga(action) {
	try {
		const mmbrSeq = action.payload.mmbrSeq;
		const param = {
			REQUEST_API: Constants.MEMBERSHIP_API.MMBR_TYPE,
			HTTP_METHOD: Constants.HTTP_METHOD.GET,
		};

		let queryParam = {
			MMBR_SEQ: mmbrSeq,
		};

		param.REQUEST_API = encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

		const { data } = yield axios({
			method: "post",
			baseURL: "/common/api",
			data: qs.stringify(param),
			CancelToken: source.token,
		});

		//const result = JSON.parse(data.RESP_RESULT.RESP_RESULT.result);
		yield put(MMBR_TYPE_SUCCESS(data.RESP_RESULT.RESP_RESULT));
	} catch (e) {
		yield put(MMBR_TYPE_FAILURE(e));
	}
}

export function* onStarPointRequest() {
	yield takeLatest(types.STAR_POINT_REQUEST, starPointSaga);
}

export function* onProductListRequest() {
	yield takeLatest(types.PRODUCT_LIST_REQUEST, productListSaga);
}

export function* onPointUseListRequest() {
	yield takeLatest(types.POINT_USELIST_REQUEST, pointUseListSaga);
}

export function* onPointSaveListSaga() {
	yield takeLatest(types.POINT_SAVELIST_REQUEST, pointSaveListSaga);
}

export function* onSetGoalsSaga() {
	yield takeLatest(types.SET_GOALS_REQUEST, setGoalsSaga);
}

export function* onUpdateTargetSaga() {
	yield takeLatest(types.GET_GOALS_REQUEST, updateTargetSaga);
}

export function* onDeleteTargetSaga() {
	yield takeLatest(types.DELETE_TARGET_REQUEST, deleteTargetSaga);
}

export function* onExchangeProductSaga() {
	yield takeLatest(types.EXCHANGE_PRODUCT_REQUEST, exchangeProductSaga);
}

export function* onExchangeHistorySaga() {
	yield takeLatest(types.EXCHANGE_HISTORY_REQUEST, exchangeHistorySaga);
}

export function* onResendProductSaga() {
	yield takeLatest(types.RESEND_PRODUCT_REQUEST, resendProductSaga);
}

export function* onProfilePhotoSaga() {
	yield takeLatest(types.PROFILE_PHOTO_REQUEST, profilePhotoSaga);
}

export function* onMmbrTypeSaga() {
	yield takeLatest(types.MMBR_TYPE_REQUEST, mmbrTypeSaga);
}

export default function* StarshopSaga() {
	yield all([
		call(onStarPointRequest),
		call(onProductListRequest),
		call(onPointUseListRequest),
		call(onPointSaveListSaga),
		call(onSetGoalsSaga),
		call(onUpdateTargetSaga),
		call(onDeleteTargetSaga),
		call(onExchangeProductSaga),
		call(onExchangeHistorySaga),
		call(onResendProductSaga),
		call(onProfilePhotoSaga),
		call(onMmbrTypeSaga),
	]);
}
